import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export interface CrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: CrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  if (!items || items.length === 0) return null;
  return (
    <nav className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 mt-2 sm:mt-3" aria-label="Breadcrumb">
      <ol className="flex items-center text-sm text-gray-500">
        <li className="flex items-center">
          <Link to="/" className="inline-flex items-center hover:text-gray-700">
            <Home className="h-4 w-4 mr-1" />
            Accueil
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            <ChevronRight className="h-4 w-4 mx-2 text-gray-400" />
            {item.to ? (
              <Link to={item.to} className="hover:text-gray-700">
                {item.label}
              </Link>
            ) : (
              <span className="text-gray-700 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;


